<strong class="text-lg font-semibold mt-6 pt-2 ml-3 mr-3 border-box">{{ selectedImage()?.name }}</strong>

<div class="flex flex-col items-center p-rel mt-2 mb-2 border-box">
  <div
    class="gallery-navigator left"
    data-testid="image-carousel-previous"
    (click)="showPrevious()"
  >
    @if (hasPrevious()) {
      <soft-ds-icon name="fa-regular fa-chevron-left" size="xl" class="icon" />
    }
  </div>

  <div class="image-container">
    @if (selectedImageURL(); as url) {
      <img [attr.src]="url" alt="currently selected image" data-testid="image-carousel-image" />
    }
  </div>

  <div class="gallery-navigator right" data-testid="image-carousel-next" (click)="showNext()">
    @if (hasNext()) {
      <soft-ds-icon name="fa-regular fa-chevron-right" size="xl" class="icon" />
    }
  </div>

  <div class="flex flex-row p-abs center gallery-stepper-container">
    <div class="gallery-stepper">
      @for (image of imageList(); track $index; let i = $index) {
        <div
          class="gallery-indicator"
          data-testid="image-carousel-indicator"
          [class.active]="index() === i"
          (click)="select(i)"
        ></div>
      }
    </div>
  </div>
</div>
